<div
  class="rs-panel-big rs-bg-c2 rs-panel-clickable jsrs-clickable rs-clickable rs-margin-bottom4-m"
  *ngIf="eligibleToDisplayProgressBar"
  (click)="onClickOnInstalmentPlanCard()"
  data-tms-event="card-click-impression"
  data-tms-card-zone="mybill.overview"
  data-tms-button-zone="mybill.overview"
  data-tms-card-name="active instalment plan"
  data-tms-button-name="active instalment plan"
  data-cy="myBillInstalmentPlanCard"
>
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column">
      <p class="rs-tit3">{{ 'bills.instalment.titleCard' | translate }}</p>
      <my-bill-instalment-plan-progress-bar
        [instalmentPlanInformation]="instalmentPlanInformation"
      ></my-bill-instalment-plan-progress-bar>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <span class="rs-panel-clickable-arrow" aria-hidden="true"></span>
    </div>
  </div>
</div>
